<app-core-popup
  [header]="'case.payment-informations.popup-header' | translate"
  [dialogStyle]="{ width: '50vw' }"
  [saveText]="(payment.id ? 'common.update' : 'common.save') | translate"
  (chooseOn)="savePayment()"
  (closeOn)="closePayment()"
  #formPopup
>
  <div class="row">
    <!-- Sol Kısım (col-7) -->
    <div class="col-md-7">
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <label class="form-label required-star" for="">{{
            "case.payment-informations.payment-type" | translate
          }}</label>
          <p-dropdown
            [options]="paymentMethods"
            [placeholder]="'case.payment-informations.payment-type' | translate"
            [filter]="true"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="payment.paymentType"
            (onChange)="paymentMethodChange()"
            appendTo="body"
          >
          </p-dropdown>

          <small *ngIf="isSubmit && !payment?.paymentType" class="required">
            {{ "validation.required" | translate }}
          </small>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label required-star" for="">{{
            "case.payment-informations.date" | translate
          }}</label>

          <p-calendar
            [showTime]="false"
            appendTo="body"
            [showButtonBar]="true"
            [(ngModel)]="payment.paymentDate"
            (onSelect)="getCurrencyRate()"
            [placeholder]="'case.payment-informations.date' | translate"
            [minDate]="minSelectableDate"
            [maxDate]="maxSelectableDate"
          >
          </p-calendar>

          <small *ngIf="isSubmit && !payment?.paymentDate" class="required">
            {{ "validation.required" | translate }}
          </small>
        </div>

        <div class="col-md-6 mb-3">
          <label class="form-label" for="">{{
            "case.payment-informations.provision-no" | translate
          }}</label>
          <input
            type="text"
            [(ngModel)]="payment.provisionNo"
            class="form-control"
          />
          <small *ngIf="(isProvisionRequired && !payment.provisionNo) || (isProvisionRequired && !payment.provisionNo && isSubmit)" class="required">
            {{ "validation.required" | translate }}
          </small>
        </div>
        <div class="col-md-12 mb-3">
          <label class="form-label required-star" for="">{{
            "case.payment-informations.instituation" | translate
          }}</label>
          <p-dropdown
            [options]="institutions"
            [placeholder]="'case.payment-informations.instituation' | translate"
            [filter]="true"
            [(ngModel)]="payment.institution"
            appendTo="body"
          >
          </p-dropdown>
          <small *ngIf="(isInstitutionRequired && !payment.institution) || (isInstitutionRequired && !payment.institution && isSubmit)" class="required">
            {{ "validation.required" | translate }}
          </small>
        </div>

        <div class="col-md-12 mb-3">
          <label class="form-label" for="">{{
            "case.payment-informations.staff" | translate
          }}</label>
          <p-dropdown
            [options]="staffs"
            [placeholder]="'case.payment-informations.staff' | translate"
            [filter]="true"
            [(ngModel)]="payment.staff"
            appendTo="body"
          >
          </p-dropdown>
          <small *ngIf="(isStaffRequired && !payment?.staff ) || (isStaffRequired && !payment?.staff && isSubmit)" class="required">
            {{ "validation.required" | translate }}
          </small>
        </div>
      </div>
    </div>

    <!-- Sağ Kısım (col-5) -->
    <div class="col-md-5">
      <div class="row mb-3">
        <div class="col-md-12 mb-3">
          <label class="form-label required-star" for="">{{
            "case.payment-informations.exchange-type" | translate
          }}</label>
          <p-dropdown
            [options]="currencies"
            [placeholder]="
              'case.payment-informations.exchange-type' | translate
            "
            [filter]="true"
            [loading]="!currencies || currencies.length === 0"
            [(ngModel)]="payment.exchangeType"
            (onChange)="exchangeTypeChange()"
            appendTo="body"
          >
          </p-dropdown>

          <small *ngIf="isSubmit && !payment?.exchangeType" class="required">
            {{ "validation.required" | translate }}
          </small>
        </div>

        <div class="col-md-12 mb-3">
          <label class="form-label required-star" for="">{{
            "case.payment-informations.total" | translate
          }}</label>

          <div></div>
          <p-inputNumber
            [(ngModel)]="payment.total"
            inputId="minmaxfraction"
            mode="decimal"
            [placeholder]="'case.payment-informations.total' | translate"
            [minFractionDigits]="2"
            [min]="1"
            [maxFractionDigits]="2"
            (onInput)="totalChange()"
          />
          <small
            *ngIf="isSubmit && payment?.total == undefined"
            class="required"
          >
            {{ "validation.required" | translate }}
          </small>
        </div>

        <div class="col-md-12 mb-3" *ngIf="!showExchangeRate">
           <!--{{
            "case.payment-informations.tl-suggestion" | translate
          }}-->
          <div class="tl-recomendation-container">
            <div class="tl-recomendation" (click)="payment.total = suggestedAmount; totalChange();" role="button"  tabindex="-1">{{suggestedAmount | numberComma}}</div>
          </div>
          <label class="form-label" for="">&nbsp;</label>
        </div>

        <div class="col-md-12 mb-3" *ngIf="showExchangeRate">
          <label class="form-label required-star" for="">{{
            "case.payment-informations.rate-of-exchange" | translate
          }}</label>

          <p-inputNumber
            [(ngModel)]="payment.rateOfExchange"
            inputId="minmaxfraction"
            [min]="0"
            (onInput)="totalChange()"
            mode="decimal"
            [placeholder]="
              'case.payment-informations.rate-of-exchange' | translate
            "
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
          />
          <small
            *ngIf="isSubmit && payment?.rateOfExchange == undefined"
            class="required"
          >
            {{ "validation.required" | translate }}
          </small>
        </div>

        <div class="col-md-12 mb-3">
          <label class="form-label" for="">{{
            "case.payment-informations.tl-total" | translate
          }}</label>

          <p-inputNumber
            [(ngModel)]="payment.totalTL"
            inputId="minmaxfraction"
            mode="decimal"
            [placeholder]="'case.payment-informations.tl-total' | translate"
            [minFractionDigits]="2"
            [min]="1"
            [maxFractionDigits]="2"
            [disabled]="true"
          />
          <small
            *ngIf="isSubmit && payment?.totalTL == undefined"
            class="required"
          >
            {{ "validation.required" | translate }}
          </small>
        </div>
      </div>
    </div>
  </div>
</app-core-popup>
